import Vue from 'vue';
import ValueCell from '@/components/answers/ValueCell.vue';
import ReferenceCell from '@/components/answers/ReferenceCell.vue';
import ComputationCell from '@/components/answers/ComputationCell.vue';
import AnswerExplaination from '@/components/answers/AnswerExplaination.vue';
import AnswerMatrix from '@/components/answers/AnswerMatrix.vue';
import AnswersColumns from '@/components/answers/AnswerColumns.vue';
import AnswersRow from '@/components/answers/AnswersRow.vue';
import AnswerCell from '@/components/answers/AnswerCell.vue';
import HeaderCell from '@/components/answers/HeaderCell.vue';
import ValueValidationMessage from '@/components/answers/ValueValidationMessage.vue';
import RowPicker from '@/components/answers/RowPicker.vue';
import OrganizationSearchTool from '@/components/answers/OrganizationSearchTool.vue';

Vue.component('value-cell', ValueCell);
Vue.component('computation-cell', ComputationCell);
Vue.component('ref-cell', ReferenceCell);
Vue.component('answer-explain', AnswerExplaination);
Vue.component('answer-matrix', AnswerMatrix);
Vue.component('answer-columns', AnswersColumns);
Vue.component('answers-row', AnswersRow);
Vue.component('answer-cell', AnswerCell);
Vue.component('header-cell', HeaderCell);
Vue.component('value-validation-message', ValueValidationMessage);
Vue.component('row-picker', RowPicker);
Vue.component('organization-search-tool', OrganizationSearchTool);
